export default __webpack_public_path__ + "static/media/library-white.7d4aea3f.svg";